module.exports = __webpack_public_path__ + "static/media/3.acc0fb6a.jpg";